import * as React from 'react';
import { styled } from '@linaria/react';

interface Props extends React.HTMLAttributes<HTMLInputElement> {
  wrapperProps?: React.HTMLAttributes<HTMLDivElement>;
}

function TextInput({ wrapperProps, ...delegated }: Props) {
  return (
    <Wrapper {...wrapperProps}>
      <Input {...delegated} />
      <Border />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  --inset-by: 2px;

  position: relative;
  /* When this is placed in a flex container, we probably want it to grow. If not, override with 'wrapperProps.style' */
  flex-grow: 1;
`;

const Input = styled.input`
  width: 100%;
  height: 3rem;
  padding: 0;
  padding-inline: var(--inset-by);
  margin-inline: calc(var(--inset-by) * -1);
  border: none;
  /* Border isn't visible, but it affects focus outline */
  border-radius: 2px;
  font-size: inherit;
  background: transparent;
  color: var(--color-text);

  &:focus-visible {
    outline-color: var(--color-primary);
    outline-offset: 4px;
  }
`;

const Border = styled.div`
  position: absolute;
  left: calc(var(--inset-by) * -1);
  right: calc(var(--inset-by) * -1);
  bottom: 0;
  width: 100%;
  height: 4px;
  background: var(--color-text);
  border-radius: 4px 4px 10px 10px;
  transform: scaleY(0.5);
  transform-origin: bottom center;
  transition: transform 400ms;

  ${Wrapper}:has(${Input}:focus) & {
    transform: scaleY(1);
    transition: transform 250ms;
  }
`;

export default TextInput;
